// Add the Firebase services that you want to use
import 'firebase/auth';

import { Module, ModuleWithProviders } from '@rxdi/core';
// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import * as firebase from 'firebase/app';

import { SocialLoginButtonComponent } from './components/github/social-button.component';
import { FirebaseSocialConfig } from './social.injections';
import { SocialService } from './social.service';

@Module({
  components: [SocialLoginButtonComponent],
  providers: [SocialService],
})
export class SocialModule {
  public static forRoot(config: FirebaseSocialConfig): ModuleWithProviders {
    try {
      firebase.initializeApp(config);
    } catch (e) {
      console.error(e);
    }
    return {
      module: SocialModule,
    };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'social-login-button': SocialLoginButtonComponent;
  }
}
